export const REQUEST = 'EMAIL_SUGGESTIONS_START'
interface RequestAction {
  type: typeof REQUEST
  key: string
}

export const REQUEST_SUCCESS = 'EMAIL_SUGGESTIONS_SUCCESS'
interface RequestSuccessAction {
  type: typeof REQUEST_SUCCESS
  key: string
  data: EmailSuggestionResponse[]
}

export const REQUEST_FAILURE = 'EMAIL_SUGGESTIONS_FAILURE'
interface RequestFailureAction {
  type: typeof REQUEST_FAILURE
  key: string
  error: unknown
}

export type Action = RequestAction | RequestSuccessAction | RequestFailureAction

export interface EmailSuggestionResponse {
  start: number
  end: number
  text: string
}
